import { URL_GET_USER_PERMISSIONS } from "@/requests/user";
import MockAdapter from "axios-mock-adapter/types";

export const permissionsMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_USER_PERMISSIONS).reply(200, [1, 2, 8, 34, 40, 65]);
};
